<ng-container>
  <h2
    class="text-lg font-medium mb-4 text-slate-700 dark:text-white backdrop-blur-lg"
  >
    Manage Roles
  </h2>

  <div class="card-bg rounded-md shadow-sm overflow-hidden relative">
    <div class="overflow-x-auto">
      <table class="w-full text-left text-sm">
        <thead>
          <tr class="border-b border-slate-50 dark:border-slate-600">
            <th class="px-6 py-4 font-medium text-slate-500 text-xs">
              Role Name
            </th>
            <th
              class="px-6 py-4 font-medium text-slate-500 text-xs text-right md:text-left"
            >
              Modified
            </th>
            <th class="px-6 py-4 font-medium text-slate-500 text-xs">Edit</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let role of roles()"
            class="border-b border-slate-50 dark:border-slate-600 hover:bg-slate-50/50 dark:hover:bg-slate-800/50 transition-colors last:border-0"
          >
            <td
              class="px-6 py-4 text-slate-700 font-medium dark:text-slate-200"
            >
              {{ role.name }}
            </td>
            <td class="px-6 py-4 text-slate-500 dark:text-slate-200">
              {{ role.updatedAt | date : "MM/dd/yyyy" }}
            </td>
            <td class="px-6 py-4">
              <div class="flex items-center gap-3">
                <!-- <button
                                    class="text-cyan-600 hover:text-cyan-700 text-xs font-medium hover:underline">Details</button> -->
                <button
                  [routerLink]="[role.id]"
                  [queryParams]="{ role: $safeNavigationMigration(role?.name) }"
                  class="text-purple-600 hover:text-purple-700 text-xs font-medium cursor-pointer hover:underline"
                >
                  Menu Access
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    @if(isLoading()){
    <div class="h-[50vh]">
      <app-individual-toaster></app-individual-toaster>
    </div>
    } @if(!isLoading() && roles().length === 0){
    <div
      class="flex flex-col items-center justify-center h-full py-12 text-gray-500"
    >
      <svg
        class="w-16 h-16 mb-4 text-gray-300"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
        ></path>
      </svg>
      <p class="text-lg font-medium">No data available</p>
      <p class="text-sm mt-1">Data will appear here when available</p>
    </div>
    }
  </div>
</ng-container>

<div class="mt-8">
  <app-audit-log-panel [entityType]="auditEntityTypes" [showProductFilter]="false" [showTitle]="true"
    title="Menu Access Audit Trails">
  </app-audit-log-panel>
</div>